<template>
  <div
    id="app"
    class="relative sm:w-wrapper mx-auto sm:my-8 p-6 sm:p-12 bg-app-background"
  >
    <navigation />
    <router-view></router-view>
  </div>
</template>

<script>
import Navigation from "./components/Global/Navigation";

export default {
  name: "app",
  components: {
    Navigation
  }
};
</script>

<style lang="scss">
/* purgecss start ignore */
* {
  // @FIXME
  transition: color 0.2s ease, background-color 0.2s ease;
}

html,
body {
  @apply .text-text .font-mono .bg-html-background;
}

a,
button {
  transition: 0.2s ease;
}

.button,
button {
  transform: scale(1);

  &:hover {
    transform: scale(1.05);
  }
}

.link {
  @apply .text-primary .relative .z-20;

  &::after {
    @apply .absolute .right-0 .z-10 .bg-primary .opacity-25;

    content: "";
    bottom: -25%;
    height: 75%;
    width: calc(100% - 1rem);
    transition: 0.2s ease;
  }

  &:hover,
  &:focus {
    &::after {
      @apply .w-full .bg-primary-swap .opacity-50;
    }
  }
}

.link--hover {
  &::after {
    @apply .opacity-0;
  }
}

.link-basic {
  @apply text-gray-500;

  &:hover,
  &:focus {
    @apply text-primary;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/* purgecss end ignore */
</style>
